module.exports = __webpack_public_path__ + "static/img/homedepot.754598d6.jpg";